import { DigitalFarmerAccount } from '../../azure-b2c/storage'

export const isDigitalFarmerAccount = (
  option: string | DigitalFarmerAccount,
): option is DigitalFarmerAccount => {
  return typeof option === 'object' && 'accountNumber' in option
}

export const getAccountName = (option: string | DigitalFarmerAccount): string => {
  if (isDigitalFarmerAccount(option)) {
    return option.accountName
  }
  return option
}
